import React from 'react'; 
import './Art-Therapy.css'; 
import Navbar from '../../Navbar/Navbar'; 
import '../../Button.css'; 

function ArtTherapy() {
  window.scrollTo(0, 0);
    return (
      <>
          
          <div className="Art-Therapy">

          <form method="get" action="#/art-therapy-mandarin"> 
            <button id="the-button" type='btn'>普通話</button> 
          </form> 

            <h1 className="exhibition">Art Therapy</h1> 
            <hr /> 

            <h5 id="caption">
              April 29 – May 27, 2016 
            </h5> 

            <img id="image-thing-at" src="AT1.jpeg" /> 

            <h5 id="caption">
              Artist: Cai Jiang 
            </h5> 
            <h5 id="caption">
              Curator: Liu Wei (Lena Liu) 
            </h5> 
            <h5 id="caption">
              Academic Support: Juan Punt in Collaboration with WhiteBox Gallery, NY 
            </h5> 
            <h5 id="caption">
              Opening Ceremony: April 29, 2016; 3:00 p.m. 
            </h5> 
            <h5 id="caption">
              Host: American Asian Culture Media Group,
              Red Art Museum. 2nd Floor 
            </h5> 

            <p id="art-paragraph-other">
            When I first met Cai Jiang in his studio in 2015, I felt very strange at the time. He was 
            blindfolded to create his art. After seeing many of his works, I have a new understanding 
            of Cai Jiang. He introduced his works to me, and talked about himself, explaining his 
            experience and artistic thoughts. He was also a Chinese Medicine Practitioner while he was 
            an artist. He immigrated to New York, USA in 1979.37 years appears to be exhausting to the 
            body and soul of the wanderer. He devoted himself to the study of Chinese Medicine, the yin 
            and the yang, blindfolded, no external pressure and interference, only the real inner world, 
            talking to himself, healing his injured heart. I miss my hometown, and I thank you now. 
            </p>
            <p id="art-paragraph-other">
            Chinese Medicine believes that the human body is originally a yin and yang coordinated whole. 
            Losing the balance of yin and yang, losing the visual pleasure, and the body and the mind become 
            exhausted. Cai Jiang pleasantly discovered that his yin and yang theory combined with contemporary 
            art creation has healed his wandering and tired heart. This yin and yang harmony is expressed in 
            his contemporary art creations. 
            </p>
            <p id="art-paragraph-other">
            He is the only creator, and many collectors are very fond of his work. The body and mind, the family, 
            the society, the only harmony, the sun shines, the world will be infinitely beautiful. Healing art. 
            </p>
            <p id="art-paragraph-other">
            These distinctive pieces have a mysterious sense of esoteric and space with the avant-garde art pioneer 
            Lucio Fontana (the unique artist style of the cut canvas, which gives the work a provocative yet elegant 
            feeling) or the specific art association of Master Murakami Saburo (the confrontation with flat materials, 
            with a series of broken cardboard on the body through a series of paper screens to capture a new architectural 
            form) influences. 
            </p>
            <p id="art-paragraph-other">
            Cai Jiang’s creative methodology is rigorously following the derivative and most direct approach of Chinese 
            Taoist Philosophy. The unpredictable aesthetic in the final work, through blindfolded eyes, uses consciousness 
            to create, and condenses into a moment of power and beauty. 
            </p>
            <p id="art-paragraph-other">
            The first chapter of the trilogy of the entire art performance begins behind a two-meter square, three layer canvas. 
            Cai Jiang, artist shaman, blindfolded through the entire canvas surface, each gesture is full of tension, each movement 
            is carefully designed and connected with its consciousness. Through behavior, a wide flow of space and follow-up 
            movements are extended; an incomprehensible, painful, and tangled behavior echoes the natural structure of nature 
            (such as thunder, heavy rain, or the madness of a hurricane). Through blindfolding, the artist created a space for 
            wireless freedom to overcome obstacles, get rid of the focus of the naked eye, and clear up thoughts and consciousness. 
            </p>
            <p id="art-paragraph-other">
            The second chapter incorporates the waving and the wandering of the rope, as well as the twine of different sizes, 
            to repair the original homogeneous, static planar form. This behavior symbolizes a healing of the mind and the body, 
            reaching an unexpected new balance. (for Cai Jiang, artistic creation is the deconstruction of intentional behavior, 
            creating a new balance of freedom from nothing). These two behaviors seem to depend on the purpose of Surrealism and 
            Dadaism, but they differ because of their lack of decision, choice, and opportunity. Each step is subconsciously 
            designed and reorganized, so the results are random. 
            </p>
            <p id="art-paragraph-other">
            The third and final steps are done by the viewer in front of the artist Shaman. When he takes off the eye mask, he 
            guides the viewer to pick one of the pre-mixed pigments, each color representing a state of mind. (for example, blue 
            represents the power of yin, red represents the power of yang, yellow represents neutrality, etc.). When the audience 
            picks their own colors, they need to cover their eyes, holding a paint can in one hand, and swaying the paint into a 
            torrent that forms a natural image. The power of the finished work can be compared to the masterpieces of the artist 
            Andre Masson or Jackson Pollack, or paintings by Australian indigenous wizards. 
            </p>
            <p id="art-paragraph-other">
            Cai Jiang’s “experience” can be regarded as a powerful work of art, or a solemn healing ceremony. “Performance Paintings” 
            retain a long-lasting experience in human memory and ideology because of their power and influence. Sticking to or escaping 
            from the form of artistic creation, behavioral paintings give us a new way of watching and healing, so that the material 
            itself and the human spirit meet. 
            </p> 

          </div>
        </> 
    );
  }
  
  export default ArtTherapy; 